module.exports = __webpack_public_path__ + "static/media/al_bg.473921c6.png";